import Vue from "vue";
import vueCustomElement from 'vue-custom-element';
// import wrap from "@vue/web-component-wrapper";

import App from "./App.vue";

// const wrappedElement = wrap(Vue, App);
// window.customElements.define("giny-port", wrappedElement);

// Enable the plugin
Vue.use(vueCustomElement);

// Register your component
Vue.customElement('giny-port', App, {
  // Additional Options: https://github.com/karol-f/vue-custom-element#options
  shadow: true,
  shadowCss: `
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;700&display=swap');
  @import url('https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css');
  *{
    font-family: 'Open Sans', sans-serif;
    font-size:18px;
  }

  strong{
    font-size:inherit;
  }

  .badge-primary{
    background-color:#114293;
  }

  .card{
    border:0px!important;
    border-radius:0px!important;
  }

  .card-header{
    background-color:#002664;
    color:#fff;
    border-radius:0px!important;
  }

  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -.125em;
  }

  .svg-inline--fa.fa-w-18 {
    width: 1.125em;
  }

  h1{
    font-size: 2.5rem;
    font-weight:700;
    line-height: 1.2;
  }

  h3{
    font-size: 1.75rem;
    margin-bottom: .5rem;
    font-weight: 700;
    line-height: 1.2;
  }

  h5{
    font-size: 15px;
    margin-bottom: 0;
    font-weight: 700;
    line-height: 1.2;
  }
 
  .widget-table .card-body{
    background-color:#EAEAF1;
    padding:20px;
  }

  .widget-table table td,
  .widget-table table th{
    padding:13px 13px 13px 0;
    font-size:15px;
    border-top:1px solid #707070;
  }
  .widget-table table th{
    border-top:0;
  }
  .svg-inline--fa.fa-w-20 {
    width: 1.25em;
  }

  .fa-3x {
      font-size: 3em;
  }
  .widget-anual-report .card{
    background-color:#EAEAF1;
    padding-bottom:30px;
  }

  .widget-anual-report .card-body{
    border-bottom:1px solid #707070;
    padding:10px 0;
  }

  .widget-summary .card{
    display:block;
  }

  .widget-summary .card-body{
    padding-left:0;
    padding-top:0;
    padding-right:0;
  }
  .widget-anual-report .col-percent{
    text-align:left;
  }

  .widget-summary table{
    margin-top:20px;
    margin-left:20px;
    width:calc(100% - 40px);
   
  }

  .widget-summary table *{
    font-size:20px!important;
    color:#4D5357;
  }

  .widget-summary table tr{
    padding:30px 0;
    border-bottom:1px solid #4D5357;
  }

  .widget-summary table td.icon-col{
    width:55px;
    padding:5px 10px 5px 0;
  }

  .widget-summary table td.col-number{
    width:30px;
    padding:10px;
  }

  .widget-summary table .img-icon svg{
    width:100%;
    height:auto;
  }

  .widget-anual-report .card-body *{
    color:#4D5357!important;
    font-size:14px!important;
  }


  .widget-anual-report .col-type{
    font-weight:bold;
  }

  .widget-anual-report .svg-inline--fa{
    height:0.8em;
  }
  .widget-anual-report .badge.bg-darkred{
    background-color:#fff;
  }

  .widget-mairitim-container .bg-serveismar-ports{
    background-color:#0073cf;
  }
  .widget-mairitim-container .bg-serveismar-ports{
    padding-top:20px;
    padding-bottom:20px;
  }
  .widget-mairitim-container .bg-serveismar-ports ul{
    list-style:none;
    margin-left:0;
    padding-left:0;
  }
  .widget-mairitim-container .bg-serveismar{
    background-color:#002664;
  }
  .widget-mairitim-container .bg-serveismar-dusk{
    background-color:#114293;
  }
  .widget-callport .card-text span.border{
    border:0px!important;
    border-radius:0px!important;
    margin-bottom:10px;
    display:inline-block;
    padding:5px 15px;
    background-color:#fff;
    font-size:16px;
    color:#4D5357;
  }
  .widget-callport .card{
    background-color:#EAEAF1;
  }

  .widget-callport h1{
    font-size:30px;
    padding-bottom:15px;
    color:#4D5357;
  }

  .widget-callport .img-icon{
    text-align:center;
    padding:40px 0 10px 0;
  }
  .widget-reserves .card{
    background-color:#EAEAF1;
    display:block;
  }

  .widget-reserves .card-body{
    background-color:#EAEAF1;
  }

  .widget-reserves .subtitol{
    display:block;
  }

  .widget-reserves .percentatge-box{
    background-color:#DEDEEA;
  }

  .widget-reserves .capacitat-box{
    text-align:left;
    padding:0;
    margin:5px 20px;
    flex:0;
  }

  .widget-reserves .capacitat-box h1,
  .widget-reserves .capacitat-box h5{
    color:#4D5357!important;
  }
  .widget-reserves .capacitat-box .badge{
    background-color:transparent;
  }
  .widget-reserves .capacitat-box h5{
    font-weight:800;
    font-size:25px;
  }
  .widget-reserves .capacitat-box.first{
    border-bottom:1px solid #707070;
  }
  .widget-reserves .bg-success, .widget-reserves .badge-success{
    background-color:#58A618!important;
  }
  .widget-reserves .progress-bar, .widget-reserves .badge-primary{
    background-color:#009FDA;
  }

  .widget-reserves .progress{
    border-radius:16px;
  }

  .widget-reserves .progress .progress-bar{
    color:#009FDA;
  }

  .widget-reserves .progress .progress-bar.second{
    color:#002664;
  }

  .widget-meteo .bg-darkblue{
    background-color:#114293;
    color:#fff;
  }
  .widget-meteo .bg-royalblue{
    background-color:#009FDA;
  }
  .widget-meteo .bg-royalblue *{
    color:#fff;
  }

  .widget-meteo .bg-beige{
    background-color:#f5deb3;
  }

  .widget-meteo .bg-beige .bg-dark{
    background-color:#f47b29!important;
  }

  .widget-mairitim-container .bg-primary{
    background-color:#0073CF;
  }

  .widget-temps-access .subtitol{
    background-color:#0073CF;
    width:100%;
    display:block;
    border-radius:0;
    color:#fff;
    text-align:left;
    padding:15px 20px;
    font-size:15px;
  }
  .widget-temps-access .card{
    display:block;
  }
  .widget-temps-access .temps-acces-time{
    background-color:#009FDA;
    color:#fff;
    display:inline-block;
    margin:auto;
    padding:20px 30px;
    border-radius:10px;
    font-size:22px!important;
    font-weight:bold!important;
  }
  .widget-temps-access .temps-acces-time *{
    font-size:22px!important;
    font-weight:bold!important;
  }
  .widget-temps-access .card{
    background-color:#EAEAF1;
  }
  `
});